import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import logger from '~/services/logger';
import OnAir from './OnAir';
import { JWTOnAir } from './types';
import OnAirSessionProvider from './contexts/Session';
import MessageManagerProvider from './contexts/MessageManager';
import OnAirErrorBoundary from './components/OnAirErrorBoundary';

type OnAirPageProps = {
	isEmbedded: boolean;
	jwt: JWTOnAir;
	sessionRegistrationId: string;
	webinarId: string;
	sessionCountryCode?: string;
};

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			// Prevent queries from throwing errors that crash the app
			useErrorBoundary: false,
			// Retry failed queries with exponential backoff
			retry: 3,
			retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
			// Log query errors globally
			onError: (error: any) => {
				logger.error('watchPage::React Query error', {
					error,
					message: error?.message,
					statusCode: error?.statusCode || error?.response?.status,
				});
			},
		},
	},
});

const OnAirPage = ({
	isEmbedded,
	jwt,
	sessionRegistrationId,
	webinarId,
	sessionCountryCode,
}: OnAirPageProps) => (
	<OnAirErrorBoundary webinarId={webinarId}>
		<QueryClientProvider client={queryClient}>
			<OnAirSessionProvider
				isEmbedded={isEmbedded}
				jwt={jwt}
				sessionRegistrationId={sessionRegistrationId}
				sessionCountryCode={sessionCountryCode}
			>
				<MessageManagerProvider>
					<OnAir isEmbedded={isEmbedded} webinarId={webinarId} />
				</MessageManagerProvider>
			</OnAirSessionProvider>
		</QueryClientProvider>
	</OnAirErrorBoundary>
);

export default OnAirPage;
